import _ from 'lodash';

import { staticMediaStoreBaseURL } from '@/config/common';
import getInitiateWhatsappChatLinkForSARA from '@/services/landingPage.service';
import { getPageURL, PAGE_NAME } from '@/services/partnerPortal.service';

export const trustedPartners = [
  {
    alt: 'atlantis',
    sortOrder: 1,
    url: '/landing-page/trusted-partners/atlantis.png'
  },
  {
    alt: 'marriott',
    sortOrder: 9,
    url: '/landing-page/trusted-partners/marriott.png'
  },
  {
    alt: 'jumeirah',
    sortOrder: 8,
    url: '/landing-page/trusted-partners/jumeirah.png'
  },
  {
    alt: 'fairmont',
    sortOrder: 6,
    url: '/landing-page/trusted-partners/fairmont.png'
  },
  {
    alt: 'emirates-palace-abu-dhabi',
    sortOrder: 2,
    url: '/landing-page/trusted-partners/emirates-palace.png'
  },
  {
    alt: 'raffles',
    sortOrder: 7,
    url: '/landing-page/trusted-partners/raffles.png'
  },
  {
    alt: 'armani-hotels',
    sortOrder: 3,
    url: '/landing-page/trusted-partners/armani.png'
  },
  {
    alt: 'palazzo-versace',
    sortOrder: 5,
    url: '/landing-page/trusted-partners/palazzo-versace.png'
  },
  {
    alt: 'al-habtoor-palace',
    sortOrder: 4,
    url: '/landing-page/trusted-partners/al-habtoor-palace.png'
  },
  {
    alt: 'address',
    sortOrder: 10,
    url: '/landing-page/trusted-partners/address.png'
  },
  {
    alt: 'four-season',
    sortOrder: 11,
    url: '/landing-page/trusted-partners/four-season.png'
  },
  {
    alt: 'hilton',
    sortOrder: 12,
    url: '/landing-page/trusted-partners/hilton.png'
  },
  {
    alt: 'intercontinental',
    sortOrder: 13,
    url: '/landing-page/trusted-partners/intercontinental.png'
  },
  {
    alt: 'melia-desert-palm',
    sortOrder: 14,
    url: '/landing-page/trusted-partners/melia-desert-palm.png'
  },
  {
    alt: 'millennium',
    sortOrder: 15,
    url: '/landing-page/trusted-partners/millennium.png'
  },
  {
    alt: 'novotel',
    sortOrder: 16,
    url: '/landing-page/trusted-partners/novotel.png'
  },
  {
    alt: 'palace-downtown',
    sortOrder: 17,
    url: '/landing-page/trusted-partners/palace-downtown.png'
  },
  {
    alt: 'park-hyatt',
    sortOrder: 18,
    url: '/landing-page/trusted-partners/park-hyatt.png'
  },
  {
    alt: 'pullman',
    sortOrder: 19,
    url: '/landing-page/trusted-partners/pullman.png'
  },
  {
    alt: 'radisson-blue',
    sortOrder: 20,
    url: '/landing-page/trusted-partners/radisson-blue.png'
  },
  {
    alt: 'sheraton',
    sortOrder: 21,
    url: '/landing-page/trusted-partners/sheraton.png'
  },
  {
    alt: 'taj',
    sortOrder: 22,
    url: '/landing-page/trusted-partners/taj.png'
  },
  {
    alt: 'westin',
    sortOrder: 23,
    url: '/landing-page/trusted-partners/westin.png'
  }
]
  .sort((a, b) => a.sortOrder - b.sortOrder)
  .map((a) => _.omit(a, 'sortOrder'));

export const socialMediaIconList = [
  {
    url: 'https://www.linkedin.com/company/hafla-official',
    icon: 'linked-in.svg',
    alt: 'linked-in'
  },
  {
    url: 'https://www.youtube.com/channel/UCaUo41TfdsE8Lr_OCb-modg',
    icon: 'youtube.svg',
    alt: 'youtube'
  },
  {
    url: 'https://www.facebook.com/hafla.Official',
    icon: 'facebook.svg',
    alt: 'facebook'
  },
  {
    url: 'https://www.instagram.com/hafla.official',
    icon: 'instagram.svg',
    alt: 'instagram'
  },
  {
    url: 'http://www.tiktok.com/@haflaofficial',
    icon: 'tiktok.svg',
    alt: 'tiktok'
  }
];

// TODO: update later
export const companySectionData = [
  {
    href: getPageURL({ pageName: PAGE_NAME.HOME.label }),
    label: 'Home'
  },
  {
    href: getInitiateWhatsappChatLinkForSARA({
      messageBody: 'Hi Sara!'
    }),
    label: 'Contact Us',
    target: '_blank'
  }
];

export const policySectionData = [
  {
    href: getPageURL({ pageName: PAGE_NAME.TERMS_AND_CONDITIONS.label }),
    label: 'Terms & Conditions'
  }
];

export const STATS = [
  {
    label: 'Partner Satisfaction',
    value: '4.9'
  },
  {
    label: 'Support Available',
    value: '24/7'
  },
  {
    label: 'Setup Fees',
    value: '0%'
  }
];

export const PARTNER_CATEGORIES = [
  {
    icon: `${staticMediaStoreBaseURL}/landing-page/partner-categories/rentals.png`,
    title: 'Rentals',
    tags: ['280+ Partners'],
    description:
      'A wide range of furniture, from elegant dining sets to modern lounges for any event style.',
    expandedItems: [
      'Dining Tables & Chairs',
      'Sofas & Ottomans',
      'Bar Stools & High Chairs',
      'Outdoor Seating Setup',
      'Cocktail Tables & Bar Counters',
      'Lounge Seating Setup'
    ]
  },
  {
    icon: `${staticMediaStoreBaseURL}/landing-page/partner-categories/catering.png`,
    title: 'Catering',
    tags: ['150+ Partners'],
    description:
      'A wide selection of catering, from traditional Emirati & international catering to delight any palate.',
    expandedItems: [
      'Buffet',
      'Live Stations',
      'Food Boxes',
      'Grazing Table Decor & Accessories',
      'Sharing Platters',
      'Drop-off Catering'
    ]
  },
  {
    icon: `${staticMediaStoreBaseURL}/landing-page/partner-categories/venues.png`,
    title: 'Venues',
    tags: ['300+ Partners'],
    description:
      'A premier selection of venues, from banquet halls to exclusive yachts, for every type of event.',
    expandedItems: [
      'Banquets & Party Halls',
      'Meeting & Conference Rooms',
      'Villas & Farmhouses',
      'Hotels & Lawns',
      'Beaches & Parks',
      'Yachts'
    ]
  },
  {
    icon: `${staticMediaStoreBaseURL}/landing-page/partner-categories/decor.png`,
    title: 'Decor',
    tags: ['120+ Partners'],
    description:
      'Transform any space with floral arrangements, themed setups, and creative lighting.',
    expandedItems: [
      'Floral Decor',
      'Balloon Decor',
      'Lighting Decor',
      'Theme-based Decor',
      'Tabletop & Linen Decor',
      'Decorative Props'
    ]
  },
  {
    icon: `${staticMediaStoreBaseURL}/landing-page/partner-categories/artists.png`,
    title: 'Artists',
    tags: ['450+ Partners'],
    description:
      'A curated artists, entertainers, and performers to captivate your audience & elevate the experience.',
    expandedItems: [
      'DJ, Singers & Musicians',
      'Dancers & Live Performers',
      "Kid's Entertainers",
      'Emcees, Hosts & Event Specialists',
      'Photo & Videographers',
      'Valet, Bouncers & Others'
    ]
  },
  {
    icon: `${staticMediaStoreBaseURL}/landing-page/partner-categories/tents.png`,
    title: 'Tents',
    tags: ['180+ Partners'],
    description:
      'A wide array of tenting solutions, from classic to modern, to perfectly suit any outdoor event.',
    expandedItems: [
      'Frame Tent',
      'Pole Tent',
      'Clear Span Tent',
      'Geodesic Dome Tent',
      'Majlis Tent',
      'Pagoda Tent'
    ]
  },
  {
    icon: `${staticMediaStoreBaseURL}/landing-page/partner-categories/audio-visual.png`,
    title: 'Audio Visual',
    tags: ['220+ Partners'],
    description:
      'Cutting-edge audio and visual equipment, including LED walls and custom concert setups.',
    expandedItems: [
      'LED Walls & Screens',
      'Audio Systems & DJ Sets',
      'DJ Lights & Dance Floors',
      'VR Sets & Gaming Consoles',
      'Custom Concert Setup'
    ]
  },
  {
    icon: `${staticMediaStoreBaseURL}/landing-page/partner-categories/event-support.png`,
    title: 'Event Support',
    tags: ['100+ Partners'],
    description:
      'All the essential equipment for a flawless event, including power, climate control & special effects.',
    expandedItems: [
      'Inflatables, Bouncy & Games',
      'ACs, Coolers & Heaters',
      'Generators & Crowd Control',
      'Catering & Food Display',
      'Exhibition Furniture',
      'Special Effects Equipment'
    ]
  }
];

export const PATH_TO_GROWTH_STEPS = [
  {
    desc: 'Begin your journey with Sara, your Hafla onboarding specialist. Get personalized guidance to kickstart your success.',
    icon: `${staticMediaStoreBaseURL}/landing-page/path-to-growth/connect-with-your-expert.png`,
    id: 1,
    label: 'STEP 1',
    title: 'Connect with Your Onboarding Expert'
  },
  {
    desc: 'Let us know what you offer, how much you charge, and where you shine—so we can connect you with ideal clients.',
    icon: `${staticMediaStoreBaseURL}/landing-page/path-to-growth/share-your-business-profile.png`,
    id: 2,
    label: 'STEP 2',
    title: 'Share Your Business Profile'
  },
  {
    desc: 'Your account manager will fine-tune your profile, align you with client demand, and get you fully ready to go live.',
    icon: `${staticMediaStoreBaseURL}/landing-page/path-to-growth/finalize-with-manager.png`,
    id: 3,
    label: 'STEP 3',
    title: 'Finalize & Optimize with Your Manager'
  },
  {
    desc: 'Once approved, your listing goes live. Start receiving qualified leads and grow your event business with Hafla.',
    icon: `${staticMediaStoreBaseURL}/landing-page/path-to-growth/go-live.png`,
    id: 4,
    label: 'STEP 4',
    title: 'Go Live & Start Earning!'
  }
];

export const AGENTS = [
  {
    description: `Your onboarding expert and go-to for anything non-event — from account setup to payments and platform support.`,
    id: 'sara',
    name: 'Sara',
    photo: `${staticMediaStoreBaseURL}/landing-page/agents/sara.png`,
    role: 'Onboarding Specialist'
  },
  {
    description: `Your event expert — here to manage pricing, availability, and confirmations for all your event-related requests.`,
    id: 'oscar',
    name: 'Oscar',
    photo: `${staticMediaStoreBaseURL}/landing-page/agents/oscar.png`,
    role: 'Event Assistant'
  }
];

export const REVIEWS = [
  {
    id: 'maristo',
    name: 'Arjun Arora',
    role: 'Maristo Catering',
    quote: `Demonstrated strength in understanding both client and vendor requirements, ensuring alignment and delivering tailored solutions through proactive communication and consistent follow-up`,
    logo: '/partner-success-stories/maristo-catering.png'
  },
  {
    id: 'white-boutique',
    name: 'Ahmed Khattab',
    role: 'The White Boutique',
    quote:
      'Professionalism - Great communication and support - Smooth and healthy operation ',
    logo: '/partner-success-stories/the-white-boutique.png'
  },
  {
    id: 'skin-jam-ice-cream',
    name: 'Nafseena VK',
    role: 'Skin Jam Ice Cream (Gelato Divino)',
    quote: `Working with Hafla was a smooth and professional experience. The team was supportive and responsive throughout. A special mention to Siddharth, who was always reachable and extremely helpful in resolving any challenges promptly, which made the entire process seamless and stress-free.`,
    logo: '/partner-success-stories/skin-jam-ice-cream.png'
  },
  {
    id: 'valentine-crepe-house',
    name: 'Nasar km',
    role: 'Valentine crepe house',
    quote: `Hafla is one of the best event planners in the UAE. The staff are very friendly and provide excellent service.`,
    logo: '/partner-success-stories/valentine-crepe-house.png'
  },
  {
    id: 'atlantis-dubai',
    name: 'Sabrina',
    role: 'Atlantis Dubai',
    quote: `The team at Hafla is extremely efficient and consistently goes the extra mile for their clients. They are creative and continuously push the boundaries of conventional events.`,
    logo: '/partner-success-stories/atlantis-dubai.png'
  },
  {
    id: 'experts-catering',
    name: 'Yasser',
    role: 'Experts catering and events',
    quote: ` We truly appreciate the amazing collaboration between our teams. Working with you has been smooth, professional, and inspiring. Together, we've taken real steps forward in the world of event planning. Thanks for being great partners — we're excited for what's ahead!`,
    logo: '/partner-success-stories/experts-catering-and-events.png'
  },
  {
    id: 'al-habtoor',
    name: 'Maria Cruz',
    role: 'Al Habtoor City Hotels',
    quote:
      'Their approach is highly professional, and they are both flexible and cooperative.',
    logo: '/partner-success-stories/al-habtoor-city-hotels.png'
  }
];

export const APP_FEATURES = [
  {
    description: 'View, accept, and manage all your bookings in one place',
    icon: 'booking.png',
    key: 'booking',
    title: 'Booking Management'
  },
  {
    description: 'Track your earnings, ratings, and growth metrics',
    icon: 'analytics.png',
    key: 'analytics',
    title: 'Performance Analytics'
  },
  {
    description: 'Get instant alerts for new opportunities and updates',
    icon: 'notifications.png',
    key: 'notifications',
    title: 'Smart Notifications'
  },
  {
    description: 'Access help anytime — with dedicated support.',
    icon: 'support.png',
    key: 'support',
    title: '24/7 Support'
  }
];

export const FAQs = [
  {
    question: 'What are the costs associated with partnering with Hafla?',
    answer: `Hafla’s business model is built on a simple philosophy: your success = our success.

This is why we charge a 0% setup/onboarding fee to eliminate any initial financial barriers. By partnering with us, you gain immediate access to a massive customer reach and our AI-powered platform without any upfront costs. This allows you to focus your resources on growing your business, effortlessly streamline your operations, and unlock unprecedented growth. Our commitment to your success is at the core of everything we do.`,
    sortOrder: 0
  },
  {
    question: 'What kind of support can I expect as a Hafla partner?',
    answer:
      'You can expect 24/7 support, dedicated onboarding assistance, marketing resources, and a partner dashboard to manage operations effectively.',
    sortOrder: 2
  },
  {
    question: 'What happens after I partner with Hafla?',
    answer: `After you partner with Hafla, you can expect a seamless transition from onboarding to actively growing your business:

Profile Activation and Go-Live: Once our onboarding account manager finalizes your details, your profile will be created and activated in our system. Your products and service offerings will then be instantly available for booking by our planners and hosts.

Managing Your Business: You'll get full access to our Partner Portal app, which is your central hub for business management on the go. You'll receive real-time notifications via WhatsApp with all order details, and your quick response via the app is key to converting leads and securing bookings.

Dedicated Support: Our planning team will reach out with inquiries to confirm availability and pricing. If you have any questions, you can always request assistance. Our operations team will also connect and plan with you to ensure every event is executed flawlessly.`,
    sortOrder: 1
  }
]
  .sort((a, b) => a.sortOrder - b.sortOrder)
  .map((a) => _.omit(a, 'sortOrder'));
